/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import {
  selectInterventionsChecklistValue,
  calculatorActions,
  selectServiceDataForm,
  selectInterventionsValue,
  selectReportName,
  selectState,
  selectTouched
} from '../../../../redux/calculatorSlice';
import {
  InterventionsChecklistForm,
  IFoodSecurity,
  InterventionsCommonForm,
  FoodSecurityForm
} from '../../../../interfaces/interventions.interface';
import { CalculatorEnum } from '../../../../interfaces/calculator.interface';
import {
  InterventionHeader,
  InterventionBody,
  InterventionFooter,
  InterventionContainer,
  InterventionFieldNoteDialog
} from '../Intervention';
import { FormValidations, Constants } from '../../../../utils';
import useDebounceEffect from '../../../../hooks/useDebounceEffect';
import { FoodSecurity as FoodSecurityClass } from '../../../../calculations';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router';

const { DIALOG_MODES } = Constants,

 FoodSecurity: FunctionComponent = () => {

  const dispatch = useDispatch(),
  navigate = useNavigate(),
  location = useLocation(),


   switchValue = useSelector(
    selectInterventionsChecklistValue(InterventionsChecklistForm.FoodSecurity)
  ),
   foodSecurityData = useSelector(
    selectInterventionsValue(CalculatorEnum.FoodSecurity)
  ),

   serviceData = useSelector(selectServiceDataForm),
   selectedState = useSelector(selectState),

   reportName = useSelector(selectReportName),
   touched = useSelector(selectTouched),

   [reinitialize, setReinitialize] = useState(true),
   [noteName, setNoteName] = useState<string>(''),
   [noteAction, setNoteAction] = useState<'add' | 'edit' | 'delete'>(DIALOG_MODES.ADD),
   [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false),

   fields = [
    {
      text: "Number of Medicaid-enrolled caregivers identified as experiencing food insecurity and referred for SNAP, WIC, or other long-term ongoing food support",
      id: FoodSecurityForm.NumberOfCaregiversFoodInsecureAndReferred,
      showError: true,
    },
  ],

   onSubmit = (values: IFoodSecurity) => {

    if (touched) {

      dispatch(
        calculatorActions.saveReport({
          reportName,
          update: true,
          navigate:navigate,
          pathname:location.pathname
        }));

}
    dispatch(calculatorActions.goToReport(navigate));

};

  useEffect(() => {

    if (switchValue) {

      const timeout = setTimeout(() => {

        setReinitialize(false);

}, 250);

      return () => {

        clearTimeout(timeout);

};

}

}, [switchValue]);

  const form = useFormik({
    initialValues: foodSecurityData,
    onSubmit,
    validationSchema: switchValue && FormValidations.intervention({
      [FoodSecurityForm.NumberOfCaregiversFoodInsecureAndReferred]:
        FormValidations.interventionNumberOfChilds(FoodSecurityForm.NumberOfCaregiversFoodInsecureAndReferred, serviceData.csInput3),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: reinitialize || !switchValue,
  });

  useEffect(() => {

    if (!switchValue) {

      form.resetForm();
      dispatch(calculatorActions.clearInterventionData(CalculatorEnum.FoodSecurity));

}

}, [switchValue]);

  useDebounceEffect(() => {

    const hasBeenEdited = Object.keys(form.values).some(
      (key) => !!form.values[key]
    );
    if (!form.dirty && !hasBeenEdited) return;
    /** Calculations happen */
    const foodSecurity = new FoodSecurityClass({
      state: selectedState,
      serviceData,
      lowEstimatedSlider: +form.values[InterventionsCommonForm.LowEstimate],
      highEstimatedSlider: +form.values[InterventionsCommonForm.HighEstimate],
      numberOfCaregiversFoodInsecureAndReferred: +form.values[FoodSecurityForm.NumberOfCaregiversFoodInsecureAndReferred],
    }),

     savingsLow = foodSecurity.foodSecurityEstimatedSavingsLow(),
     savingsHigh = foodSecurity.foodSecurityEstimatedSavingsHigh();

    if (
      +form.values[InterventionsCommonForm.SavingsLow] !== savingsLow ||
      +form.values[InterventionsCommonForm.SavingsHigh] !== savingsHigh
    ) {

      form.setValues({
        ...form.values,
        [InterventionsCommonForm.SavingsLow]: savingsLow.toString(),
        [InterventionsCommonForm.SavingsHigh]: savingsHigh.toString(),
      });

}

    form.validateForm().then((errors) => {

      const isValid = !Object.keys(errors).length;

      if (form.dirty) {

        dispatch(
          calculatorActions.setInterventionData({
            intervention: CalculatorEnum.FoodSecurity,
            value: { ...form.values, isValid: !!isValid },
          })
        );
        dispatch(calculatorActions.setSummaryData());

}

});

}, [form.values]);

  const onSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    dispatch(
      calculatorActions.toggleInterventionsChecklistValue({
        key: InterventionsChecklistForm.FoodSecurity,
        value: e.target.checked,
      })
    );

},

   onNote = (noteName: string, noteAction: 'add' | 'edit' | 'delete') => {

    setNoteName(noteName);
    setNoteAction(noteAction);
    setIsNoteDialogOpen(true);

},

   onDialogNoteClose = () => {

    setIsNoteDialogOpen(false);

};

  return (
    <>
      <InterventionContainer
        disabled={!switchValue}
        onSubmit={form.handleSubmit}
        header={
          <InterventionHeader
            title="Food Security"
            checked={switchValue}
            onChange={onSwitchChange}
          />
        }
        body={
          <InterventionBody
            description={
              <>
                Some HS Specialists administer a food security screener or in another way identify a family's need for food and either directly or through a referral register families for WIC, SNAP, or another long-term ongoing food support. The following questions ask about the actions taken by caregivers in these situations during the 12-month date range.
              </>
            }
            form={form}
            fields={fields}
            onNote={onNote}
          />
        }
        footer={
          <InterventionFooter
            hideLongTerm={true}
            form={form}
            savingsText="FoodSecurity"
            description="Percentage of Medicaid-enrolled caregivers referred for food assistance who receive ongoing food support due to HS involvement"
            onNote={onNote}
          />
        }
      />
      <InterventionFieldNoteDialog
        id={`${noteName}__${noteAction}-dialog`}
        name={noteName}
        value={form.values[noteName]}
        mode={noteAction}
        open={isNoteDialogOpen}
        onClose={onDialogNoteClose}
        form={form}
      />
    </>
  );

};

export default FoodSecurity;
